/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: e86a911c (Thu May 21 20:23:17 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  AgreementCreate,
  AgreementCreateToJSON,
  AgreementPreview,
  AgreementPreviewFromJSON,
  AgreementRecord,
  AgreementRecordFromJSON,
  AgreementSigningUrl,
  AgreementSigningUrlFromJSON,
  AgreementStatus,
  AgreementStatusFromJSON,
  AgreementTemplateFormFields,
  AgreementTemplateFormFieldsFromJSON,
  CompleteAgreementResponse,
  CompleteAgreementResponseFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface CompleteAgreementRequest
  extends runtime.BaseRequestParameters {
  uuid: string
}

export interface CreateAgreementRequest extends runtime.BaseRequestParameters {
  body: AgreementCreate
}

export interface DeleteAgreementRequest extends runtime.BaseRequestParameters {
  agreementId: string
}

export interface FetchAgreementPreviewRequest
  extends runtime.BaseRequestParameters {
  agreementId: string
}

export interface FetchAgreementSigningUrlRequest
  extends runtime.BaseRequestParameters {
  agreementId: string
}

export interface FetchAgreementStatusRequest
  extends runtime.BaseRequestParameters {
  agreementId: string
}

export interface FetchAgreementTemplateFormFieldsRequest
  extends runtime.BaseRequestParameters {
  agreementTemplateId: string
  agreementDocumentId: string
}

/**
 * AgreementsApi - interface
 *
 * @export
 * @interface AgreementsApiInterface
 */
export interface AgreementsApiInterface {
  /**
   * This marks an agreement as completed and creates an actor record for the user with new role, in the contracted validity window.  The logged in user must be the user associated with the signerUserKey on the agreementRecord and the agreement must be active and signed.  This also adds the new actorKey to the session and updates the lastSelectActorKey value, so the user can have access to there new role.  The endpoint returns the userKey and the new actorKey in order to update the login session on the FE
   * @summary Complete an open agreement.
   * @param {string} uuid Unique identifier for the invitation.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApiInterface
   */
  completeAgreementRaw(
    requestParameters: CompleteAgreementRequest
  ): Promise<runtime.ApiResponse<CompleteAgreementResponse>>

  /**
   * This marks an agreement as completed and creates an actor record for the user with new role, in the contracted validity window.  The logged in user must be the user associated with the signerUserKey on the agreementRecord and the agreement must be active and signed.  This also adds the new actorKey to the session and updates the lastSelectActorKey value, so the user can have access to there new role.  The endpoint returns the userKey and the new actorKey in order to update the login session on the FE
   * Complete an open agreement.
   */
  completeAgreement(
    requestParameters: CompleteAgreementRequest
  ): Promise<CompleteAgreementResponse>

  /**
   *
   * @summary Create a new Agreement.
   * @param {AgreementCreate} agreementCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApiInterface
   */
  createAgreementRaw(
    requestParameters: CreateAgreementRequest
  ): Promise<runtime.ApiResponse<AgreementRecord>>

  /**
   * Create a new Agreement.
   */
  createAgreement(
    requestParameters: CreateAgreementRequest
  ): Promise<AgreementRecord>

  /**
   * Cancel the adobe sign record and delete an agreement from agreement records that currently has a status of `draft`.
   * @param {string} agreementId Unique identifier for the agreement.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApiInterface
   */
  deleteAgreementRaw(
    requestParameters: DeleteAgreementRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Cancel the adobe sign record and delete an agreement from agreement records that currently has a status of `draft`.
   */
  deleteAgreement(requestParameters: DeleteAgreementRequest): Promise<void>

  /**
   * Returns a download link for a pdf preview for the specified agreementId.
   * @param {string} agreementId Unique identifier for the agreement.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApiInterface
   */
  fetchAgreementPreviewRaw(
    requestParameters: FetchAgreementPreviewRequest
  ): Promise<runtime.ApiResponse<AgreementPreview>>

  /**
   * Returns a download link for a pdf preview for the specified agreementId.
   */
  fetchAgreementPreview(
    requestParameters: FetchAgreementPreviewRequest
  ): Promise<AgreementPreview>

  /**
   * Returns the signing url for an agreement.
   * @param {string} agreementId Unique identifier for the agreement.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApiInterface
   */
  fetchAgreementSigningUrlRaw(
    requestParameters: FetchAgreementSigningUrlRequest
  ): Promise<runtime.ApiResponse<AgreementSigningUrl>>

  /**
   * Returns the signing url for an agreement.
   */
  fetchAgreementSigningUrl(
    requestParameters: FetchAgreementSigningUrlRequest
  ): Promise<AgreementSigningUrl>

  /**
   * Returns the current status for an agreement for the specified agreementId.
   * @param {string} agreementId Unique identifier for the agreement.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApiInterface
   */
  fetchAgreementStatusRaw(
    requestParameters: FetchAgreementStatusRequest
  ): Promise<runtime.ApiResponse<AgreementStatus>>

  /**
   * Returns the current status for an agreement for the specified agreementId.
   */
  fetchAgreementStatus(
    requestParameters: FetchAgreementStatusRequest
  ): Promise<AgreementStatus>

  /**
   * List of form fields that can be prefilled for an Adobe Sign agreement.
   * @param {string} agreementTemplateId Unique identifier for the chosen agreement template, which is a WorkflowId in AdobeSign.
   * @param {string} agreementDocumentId Unique identifier for the chosen agreement document, which is a LibraryDocumentId in AdobeSign.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApiInterface
   */
  fetchAgreementTemplateFormFieldsRaw(
    requestParameters: FetchAgreementTemplateFormFieldsRequest
  ): Promise<runtime.ApiResponse<AgreementTemplateFormFields>>

  /**
   * List of form fields that can be prefilled for an Adobe Sign agreement.
   */
  fetchAgreementTemplateFormFields(
    requestParameters: FetchAgreementTemplateFormFieldsRequest
  ): Promise<AgreementTemplateFormFields>
}

/**
 *
 */
export class AgreementsApi
  extends runtime.BaseAPI
  implements AgreementsApiInterface
{
  /**
   * This marks an agreement as completed and creates an actor record for the user with new role, in the contracted validity window.  The logged in user must be the user associated with the signerUserKey on the agreementRecord and the agreement must be active and signed.  This also adds the new actorKey to the session and updates the lastSelectActorKey value, so the user can have access to there new role.  The endpoint returns the userKey and the new actorKey in order to update the login session on the FE
   * Complete an open agreement.
   */
  async completeAgreementRaw(
    requestParameters: CompleteAgreementRequest
  ): Promise<runtime.ApiResponse<CompleteAgreementResponse>> {
    if (
      requestParameters.uuid === null ||
      requestParameters.uuid === undefined
    ) {
      throw new runtime.RequiredError(
        'uuid',
        'Required parameter requestParameters.uuid was null or undefined when calling completeAgreement.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/agreements/{uuid}/complete`.replace(
        `{${'uuid'}}`,
        encodeURIComponent(String(requestParameters.uuid))
      ),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompleteAgreementResponseFromJSON(jsonValue)
    )
  }

  /**
   * This marks an agreement as completed and creates an actor record for the user with new role, in the contracted validity window.  The logged in user must be the user associated with the signerUserKey on the agreementRecord and the agreement must be active and signed.  This also adds the new actorKey to the session and updates the lastSelectActorKey value, so the user can have access to there new role.  The endpoint returns the userKey and the new actorKey in order to update the login session on the FE
   * Complete an open agreement.
   */
  async completeAgreement(
    requestParameters: CompleteAgreementRequest
  ): Promise<CompleteAgreementResponse> {
    const response = await this.completeAgreementRaw(requestParameters)
    return await response.value()
  }

  /**
   * Create a new Agreement.
   */
  async createAgreementRaw(
    requestParameters: CreateAgreementRequest
  ): Promise<runtime.ApiResponse<AgreementRecord>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling createAgreement.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/agreements`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: AgreementCreateToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AgreementRecordFromJSON(jsonValue)
    )
  }

  /**
   * Create a new Agreement.
   */
  async createAgreement(
    requestParameters: CreateAgreementRequest
  ): Promise<AgreementRecord> {
    const response = await this.createAgreementRaw(requestParameters)
    return await response.value()
  }

  /**
   * Cancel the adobe sign record and delete an agreement from agreement records that currently has a status of `draft`.
   */
  async deleteAgreementRaw(
    requestParameters: DeleteAgreementRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.agreementId === null ||
      requestParameters.agreementId === undefined
    ) {
      throw new runtime.RequiredError(
        'agreementId',
        'Required parameter requestParameters.agreementId was null or undefined when calling deleteAgreement.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/agreements/{agreementId}`.replace(
        `{${'agreementId'}}`,
        encodeURIComponent(String(requestParameters.agreementId))
      ),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Cancel the adobe sign record and delete an agreement from agreement records that currently has a status of `draft`.
   */
  async deleteAgreement(
    requestParameters: DeleteAgreementRequest
  ): Promise<void> {
    await this.deleteAgreementRaw(requestParameters)
  }

  /**
   * Returns a download link for a pdf preview for the specified agreementId.
   */
  async fetchAgreementPreviewRaw(
    requestParameters: FetchAgreementPreviewRequest
  ): Promise<runtime.ApiResponse<AgreementPreview>> {
    if (
      requestParameters.agreementId === null ||
      requestParameters.agreementId === undefined
    ) {
      throw new runtime.RequiredError(
        'agreementId',
        'Required parameter requestParameters.agreementId was null or undefined when calling fetchAgreementPreview.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/agreements/{agreementId}/preview`.replace(
        `{${'agreementId'}}`,
        encodeURIComponent(String(requestParameters.agreementId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AgreementPreviewFromJSON(jsonValue)
    )
  }

  /**
   * Returns a download link for a pdf preview for the specified agreementId.
   */
  async fetchAgreementPreview(
    requestParameters: FetchAgreementPreviewRequest
  ): Promise<AgreementPreview> {
    const response = await this.fetchAgreementPreviewRaw(requestParameters)
    return await response.value()
  }

  /**
   * Returns the signing url for an agreement.
   */
  async fetchAgreementSigningUrlRaw(
    requestParameters: FetchAgreementSigningUrlRequest
  ): Promise<runtime.ApiResponse<AgreementSigningUrl>> {
    if (
      requestParameters.agreementId === null ||
      requestParameters.agreementId === undefined
    ) {
      throw new runtime.RequiredError(
        'agreementId',
        'Required parameter requestParameters.agreementId was null or undefined when calling fetchAgreementSigningUrl.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/agreements/{agreementId}/signingUrl`.replace(
        `{${'agreementId'}}`,
        encodeURIComponent(String(requestParameters.agreementId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AgreementSigningUrlFromJSON(jsonValue)
    )
  }

  /**
   * Returns the signing url for an agreement.
   */
  async fetchAgreementSigningUrl(
    requestParameters: FetchAgreementSigningUrlRequest
  ): Promise<AgreementSigningUrl> {
    const response = await this.fetchAgreementSigningUrlRaw(requestParameters)
    return await response.value()
  }

  /**
   * Returns the current status for an agreement for the specified agreementId.
   */
  async fetchAgreementStatusRaw(
    requestParameters: FetchAgreementStatusRequest
  ): Promise<runtime.ApiResponse<AgreementStatus>> {
    if (
      requestParameters.agreementId === null ||
      requestParameters.agreementId === undefined
    ) {
      throw new runtime.RequiredError(
        'agreementId',
        'Required parameter requestParameters.agreementId was null or undefined when calling fetchAgreementStatus.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/agreements/{agreementId}/status`.replace(
        `{${'agreementId'}}`,
        encodeURIComponent(String(requestParameters.agreementId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AgreementStatusFromJSON(jsonValue)
    )
  }

  /**
   * Returns the current status for an agreement for the specified agreementId.
   */
  async fetchAgreementStatus(
    requestParameters: FetchAgreementStatusRequest
  ): Promise<AgreementStatus> {
    const response = await this.fetchAgreementStatusRaw(requestParameters)
    return await response.value()
  }

  /**
   * List of form fields that can be prefilled for an Adobe Sign agreement.
   */
  async fetchAgreementTemplateFormFieldsRaw(
    requestParameters: FetchAgreementTemplateFormFieldsRequest
  ): Promise<runtime.ApiResponse<AgreementTemplateFormFields>> {
    if (
      requestParameters.agreementTemplateId === null ||
      requestParameters.agreementTemplateId === undefined
    ) {
      throw new runtime.RequiredError(
        'agreementTemplateId',
        'Required parameter requestParameters.agreementTemplateId was null or undefined when calling fetchAgreementTemplateFormFields.'
      )
    }

    if (
      requestParameters.agreementDocumentId === null ||
      requestParameters.agreementDocumentId === undefined
    ) {
      throw new runtime.RequiredError(
        'agreementDocumentId',
        'Required parameter requestParameters.agreementDocumentId was null or undefined when calling fetchAgreementTemplateFormFields.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/agreements/templates/{agreementTemplateId}/{agreementDocumentId}/formFields`
        .replace(
          `{${'agreementTemplateId'}}`,
          encodeURIComponent(String(requestParameters.agreementTemplateId))
        )
        .replace(
          `{${'agreementDocumentId'}}`,
          encodeURIComponent(String(requestParameters.agreementDocumentId))
        ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AgreementTemplateFormFieldsFromJSON(jsonValue)
    )
  }

  /**
   * List of form fields that can be prefilled for an Adobe Sign agreement.
   */
  async fetchAgreementTemplateFormFields(
    requestParameters: FetchAgreementTemplateFormFieldsRequest
  ): Promise<AgreementTemplateFormFields> {
    const response = await this.fetchAgreementTemplateFormFieldsRaw(
      requestParameters
    )
    return await response.value()
  }
}
